<div class="d-flex flex-column flex-sm-row align-items-sm-center gap-3 mb-3">
  <button
    type="button"
    class="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 ms-sm-auto justify-content-center"
    (click)="add.emit()">
    <i class="fas fa-plus" aria-hidden="true"></i>
    <span>{{ 'FreeswitchIntegration::AddIvrInstance' | abpLocalization }}</span>
  </button>
</div>
